import * as React from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';

// @ts-ignore
import { AdapterDateFns } from '@emburse/ui-core/dist/AdapterDateFns';
import { EmburseUIProvider } from '@emburse/ui-essentials';

import { AbacusThemeProvider } from '@ReactComponents/Layout/ThemeProvider';

const AbacusEmbarkProvider: React.FC<{ children?: React.ReactNode }> = function ({ children }) {
  return (
    <EmburseUIProvider
      featureFlags={{ legacyI18nSupport: true, useGridProFeatures: true }}
      theme={{ designToken: AbacusThemeProvider.getThemeOptions(), responsive: { sidebar: true } }}
      dateLocale={{ dateAdapter: AdapterDateFns, adapterLocale: AbacusThemeProvider.getDateFnsLocale() }}
    >
      {/*
        EmburseThemeProvider builds the base theme internally and exposes no seam for
        the `@mui/material/locale` bundle, so extend the theme it provides via a nested
        MUI ThemeProvider — `createTheme(outerTheme, localeBundle)` merges the active
        locale's component strings onto the existing theme.
      */}
      <ThemeProvider theme={(outerTheme) => createTheme(outerTheme, AbacusThemeProvider.getMuiMaterialLocale())}>{children}</ThemeProvider>
    </EmburseUIProvider>
  );
};

export { AbacusEmbarkProvider };
